import { selectIsLoading } from '@store/loaders'
import {
  ApiKeysActions,
  selectApiKeys,
  selectApiKeysError,
} from '@store/reducers/apiKeys'
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

export const useApiKeys = () => {
  const dispatch = useDispatch()

  const keys = useSelector(selectApiKeys)
  const loading = useSelector(selectIsLoading('api_keys_fetch'))
  const error = useSelector(selectApiKeysError)

  const refetch = () => dispatch(ApiKeysActions.fetch())

  useEffect(() => {
    dispatch(ApiKeysActions.fetch())
  }, [dispatch])

  return { keys, loading, error, refetch }
}
